import React, { Component, Fragment, createRef } from 'react'
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import { dataProdi } from '../../../dummy-data/prodi';
import { dropdownAngkatan, dataMahasiswa } from '../../../dummy-data/mahasiswa';
import { dataSemester } from '../../../dummy-data/akademik';

class HistoryMahasiswa extends Component {
    state = {
        listMahasiswa: [],
        listProdi: [],
        listAngkatan: [],
        listSemester: [],
        listStsMahasiswa: [],
        check_list: [],
        isLoad: false,
        formdata: {
            idjurusan: "",
            idjalur: "",
            semester: "",
            sts_mhs: "",
            all_smt: ""
        },
        nama_mhs: "",
        nim_mhs: "",
        status_type: "",
        semester: ""
    }

    HandleChange = (e) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                [e.target.name]: e.target.value
            }
        })
    };

    handleStatus = (e) => {
        this.setState({
            status_type: e.target.value
        })
    }

    getFilter = () => {
        this.setState({
            listAngkatan: dropdownAngkatan.map(a => ({ id_angkatan: a.value, angkatan: a.label })),
            listProdi: dataProdi.map(p => ({ id_jurusan: p.prodi_id, nama_jurusan: p.prodi_nama })),
            listSemester: dataSemester.map(s => ({ id_semester: s.semester_id, nama_semester: s.semester_nama }))
        });
    }

    execView = () => {
        // Filter mahasiswa using dummy data
        let filtered = [...dataMahasiswa];

        if (this.state.formdata.idjurusan) {
            filtered = filtered.filter(m => m.prodi_id === parseInt(this.state.formdata.idjurusan));
        }
        if (this.state.formdata.idangkatan) {
            filtered = filtered.filter(m => m.angkatan === parseInt(this.state.formdata.idangkatan));
        }

        const mappedData = filtered.map(m => ({
            nim: m.nim,
            nama: m.nama,
            detail_status: this.state.formdata.semester === 'All' ?
                [1, 2, 3, 4, 5, 6, 7].map(s => ({ semester: s, status: 'Aktif' })) :
                'Aktif'
        }));

        setTimeout(() => {
            this.setState({
                listMahasiswa: mappedData,
                idjurusan: this.state.formdata.idjurusan,
                idangkatan: this.state.formdata.idangkatan,
                semester: this.state.formdata.semester,
                isLoad: false,
                check_list: []
            });
        }, 300);
    }

    handleView = (e) => {
        e.preventDefault();
        this.setState({ isLoad: true })
        this.execView()
    }

    detailModal = (nim) => {
        let filtered = this.state.listMahasiswa.filter((list) => list.nim == nim);
        this.setState({
            nama_mhs: filtered[0].nama,
            nim_mhs: filtered[0].nim,
            listStsMahasiswa: filtered[0].detail_status
        })
    }

    toggleCheckboxAll = (event) => {
        let checkboxes = document.getElementsByName('check_list');
        if (event.target.checked) {
            for (let i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = true;
                this.state.check_list[i] = checkboxes[i].value;
            }
        } else {
            for (let i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = false;
                this.state.check_list = []
            }
        }
    }

    toggleCheckbox = (event) => {
        if (event.target.checked) {
            this.state.check_list.push(event.target.value)
        } else {
            var index = this.state.check_list.indexOf(event.target.value);
            this.state.check_list.splice(index, 1);
        }
    }

    postStatus = () => {
        if (this.state.status_type == "" || this.state.check_list.length == 0) {
            alert('status belum dipilih / tidak ada mahasiswa dipilih')
            return false
        } else {
            swal({
                icon: 'success',
                title: 'Demo Mode',
                text: 'Status berhasil diubah (simulasi)',
                timer: 1500,
                buttons: false
            });
        }
    }

    componentDidMount() {
        this.getFilter()
    }

    render() {
        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{
                                fontSize: '15px', fontWeight: 'bold', color: '#999999',
                                textTransform: 'capitalize'
                            }}>
                                Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;History Status Mahasiswa
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row" id="smoothMain">
                    <div className="col-xl-12">
                        <div className="card card-custom mb-3 pr-3 pl-3">
                            <div className="card-body">
                                <form onSubmit={this.handleView}>
                                    <div className="row">
                                        <div className="col-md-3 mt-2 mb-2">
                                            <label style={{ fontSize: '14px' }}>Program studi :</label>
                                            <select className="form-control selectCust"
                                                id="prodi"
                                                name="idjurusan"
                                                onChange={this.HandleChange}
                                                required
                                            >
                                                <option value="prodi" hidden>- Program Studi -</option>
                                                {
                                                    this.state.listProdi.map((list, i) => {
                                                        return (
                                                            <option key={i} value={list.id_jurusan}>{list.nama_jurusan}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2 mb-2">
                                            <label style={{ fontSize: '14px' }}>Tahun angkatan :</label>
                                            <select className="form-control selectCust"
                                                id="angkatan"
                                                name="idangkatan"
                                                onChange={this.HandleChange}
                                                required
                                            >
                                                <option value="" hidden>- Angkatan -</option>
                                                {this.state.listAngkatan.map((list, i) => {
                                                    return (
                                                        <option key={i} value={list.id_angkatan}>{list.angkatan}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2 mb-2">
                                            <label style={{ fontSize: '14px' }}>Semester :</label>
                                            <select id="semester" className="form-control selectCust"
                                                name="semester"
                                                onChange={this.HandleChange}
                                            >
                                                <option value="" hidden>- Semester -</option>
                                                <option value="All" > All </option>
                                                {this.state.listSemester.map((list, i) => {
                                                    return (
                                                        <option key={i} value={list.id_semester}>{list.nama_semester}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2 mb-2">
                                            <p align="right">
                                                <button
                                                    id="btn-cari"
                                                    className="btn btn-success btn-md"
                                                    style={{ borderRadius: '5px', marginTop: '28.5px' }}
                                                    type="submit"
                                                >
                                                    cari
                                                </button>
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="card card-custom">
                            <div className="card-body">
                                <p className="card-title text-center mb-5" style={{ fontSize: '25px', marginTop: '10px' }}>History Status Mahasiswa</p>
                                {
                                    this.state.isLoad ?
                                        <div id="spinner" className="loader-1 colorful mt-5 mb-5">
                                            <div className="dot" />
                                            <div className="dot" />
                                            <div className="dot" />
                                        </div>
                                        :
                                        <div className='mt-2'>
                                            <div className="table-responsive">
                                                <table id="tableabsensi" className="display expandable-table table-striped" style={{ width: '100%' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>NIM</th>
                                                            <th>Nama</th>
                                                            {
                                                                this.state.semester == "All" ? <th>Aksi</th> : null
                                                            }
                                                            {
                                                                this.state.semester == "All" ? null : <th>Keterangan Status</th>
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.listMahasiswa.map((list, i) => {
                                                                return (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        <td>{list.nim}</td>
                                                                        <td>{list.nama}</td>
                                                                        {
                                                                            this.state.semester == "All" ?
                                                                                <td>
                                                                                    <Link
                                                                                        // target={"_blank"}
                                                                                        data-toggle="modal"
                                                                                        data-target="#detailSemester"
                                                                                        onClick={() => this.detailModal(list.nim)}
                                                                                        type="button"
                                                                                        className="btn btn-primary btn-xs"
                                                                                        style={{ padding: "10px 15px 10px 15px", borderRadius: '5px' }}
                                                                                    >
                                                                                        detail semester
                                                                                    </Link>
                                                                                </td> : null
                                                                        }
                                                                        {
                                                                            this.state.semester == "All" ? null : <td>{list.detail_status}</td>
                                                                        }
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>

                        {/* detail semester per mahasiswa */}
                        <div className="modal fade" id="detailSemester" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-lg" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title" id="exampleModalLabel">History Status </h4>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={this.closeEditModal}>
                                            <span aria-hidden="true" className="close-btn">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body" >
                                        <div className="table-responsive">
                                            <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                                <thead></thead>
                                                <tbody>
                                                    <tr>
                                                        <td width="50px">Nama</td>
                                                        <td width="5px"> : </td>
                                                        <td width="200px">{this.state.nama_mhs}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>NIM</td>
                                                        <td> : </td>
                                                        <td>{this.state.nim_mhs}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="display expandable-table table-striped mt-2" style={{ width: '100%' }}>
                                                <thead>
                                                    <tr>
                                                        <th>Semester</th>
                                                        <th>Keterangan</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.listStsMahasiswa.map((list, i) => {
                                                            return (
                                                                <tr >
                                                                    <td><span class="badge badge-success">Semester {list.semester}</span></td>
                                                                    <td><span class="badge badge-primary">{list.status}</span></td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* detail semester per mahasiswa */}

                    </div>
                </div>
            </Fragment>
        )
    }
}

export default HistoryMahasiswa
